module.exports = __webpack_public_path__ + "img/author-logo.42f75199.png";